import { Col, Row, Table } from "antd";
import React, { useEffect, useState } from "react";
import { Button, Modal } from "antd";
import moment from "moment";
import { useMutation } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import HeadingBack from "../../../component/HeadingBack";
import { usePermission } from "../../../hooks/usePermission";
import { DashboardServices } from "../../../redux/Services";
import AbhaLinkedFilter from "../AbhaFilter";
const HipLog = () => {
  const filename = "Record Linked Log";
  const [FilteredData, setFilteredData] = useState([]);
  const permission = usePermission("HIP Dashboard", "List");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState({});
  const [limit, setLimit] = useState(100);
  // const [offset, setOffset] = useState(0);
  const HipLog = useSelector((state) => state.dashboard?.abdmHipLog || []);
  const totalAbhaCardsLogs = useSelector(
    (state) => state.dashboard.totalAbhaCardsLogs || ""
  );
  const { mutate: fetchAbdmHip, isLoading } = useMutation((data) =>
    dispatch(DashboardServices.fetchAbdmHipApi(data, limit, page))
  );
  const [raw, setRaw] = useState({});
  const [modal1Open, setModal1Open] = useState(false);

  useEffect(() => {
    fetchAbdmHip(filter);
    return () => {};
  }, [filter, limit, page]);
  //    console.log((JSON.parse(raw?.request_raw_data || "{}")?.demographic?.name))
  // const props = {
  //     action: '',
  //     onChange({ file, fileList }) {
  //         if (file.status !== 'uploading') {
  //             console.log(file, fileList);
  //         }
  //     },

  //     showUploadList: {
  //         showDownloadIcon: true,
  //         downloadIcon: 'Download',
  //         showRemoveIcon: true,
  //         removeIcon: <DeleteOutlined />,
  //     },
  // };

  // const json = {
  //     "firstName": "Amit",
  //     "lastName": "Smith",
  //     "isAlive": true,
  //     "age": 27,
  //     "address": {
  //         "streetAddress": "21 2nd Street",
  //         "city": "New York",
  //         "state": "NY",
  //         "postalCode": "10021-3100"
  //     },
  //     "phoneNumbers": [
  //         {
  //             "type": "home",
  //             "number": "212 555-1234"
  //         },
  //         {
  //             "type": "office",
  //             "number": "646 555-4567"
  //         }
  //     ],
  //     "children": [
  //         "Catherine",
  //         "Thomas",
  //         "Trevor"
  //     ],
  //     "spouse": null
  // };

  useEffect(() => {
    if (HipLog && HipLog.length > 0) {
      var data = [];
      HipLog.forEach((value, index) => {
        var item = {
          sno: value?.sno,
          id: value?.id,
          log_type: value?.log_type,
          requestor: value?.requestor,
          patient_name: value?.patient_name,
          reference_id: value?.reference_id,
          mobile_no: value?.mobile_no,
          heathid_no: value?.heathid_no,
          health_id: value?.health_id,
          createdAt: value?.createdAt,
          updatedAt: value?.updatedAt
        };

        data.push(item);
      });
      setFilteredData(data);
    }
    return () => {};
  }, [HipLog]);

  const headers = [
    { label: "S.No.", key: "sno" },
    { label: "Log Id", key: "id" },
    { label: "Log Type", key: "log_type" },
    { label: "Requester (HIU/HIP)", key: "requestor" },
    { label: "Patient Name", key: "patient_name" },
    { label: "Patient Id", key: "reference_id" },
    { label: "Mobile Number", key: "mobile_no" },
    { label: "ABHA Number", key: "heathid_no" },
    { label: "ABHA Address", key: "health_id" },
    { label: "Created At", key: "createdAt" },
    { label: "Updated At", key: "updatedAt" }
  ];
  const columns = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      className: "table_first_col",
      render: (value, item, index) => (page - 1) * 100 + index + 1
    },
    {
      title: "Log Id",
      dataIndex: "id",
      key: "abha_card_log_id",
      className: "table_status_col"
    },
    {
      title: "Log Type",
      dataIndex: "log_type",
      key: "log_type",
      className: "table_status_col"
    },
    {
      title: "Request Id",
      dataIndex: "request_id",
      key: "request_id",
      className: "text-capitalize"
    },

    {
      title: "Requester (HIU/HIP)",
      dataIndex: "requestor",
      key: "requestor",
      className: "text-capitalize"
    },
    {
      title: "Patient Name",
      dataIndex: "ReferenceName",
      key: "ReferenceName",
      className: "table_status_col patient",
      render: (value, item, index) => {
        let patientData = JSON.parse(item?.request_raw_data || "{}")?.query
          ?.patient_data;
        return <div>{patientData?.demographic?.name}</div>;
      }
    },
    {
      title: "Patient Reference Id",
      dataIndex: "lpl_link_reference",
      key: "ReferenceId",
      className: "table_status_col patient"
      // render: (value, item, index) => {
      //     let patientData = JSON.parse(item?.request_raw_data || "{}")?.query?.patient_data;
      //     return (
      //         <span>
      //             {patientData?.id}
      //         </span>
      //     )
      // }
    },
    {
      title: "Mobile Number",
      dataIndex: "mobile_no",
      key: "requestor",
      className: "text-capitalize",
      render: (value, item, index) => {
        let patientData = JSON.parse(item?.request_raw_data || "{}")?.query
          ?.patient_data;
        return <span>{patientData?.demographic?.mobile_no}</span>;
      }
    },

    {
      title: "ABHA Address",
      dataIndex: "ReferenceId",
      key: "ReferenceId",
      className: "table_status_col",
      render: (value, item, index) => {
        let patientData = JSON.parse(item?.request_raw_data || "{}")?.query
          ?.patient_data;
        return <span>{patientData?.id}</span>;
      }
    },

    // {
    //     title: 'URL',
    //     dataIndex: 'Status',
    //     key: 'Status',
    //     className: 'table_status_col',
    //     render: (value, item, index) => {
    //         return (
    //             <a href='#'>https://www.pathkindlabs.com/abha</a>
    //         )
    //     }
    // },
    {
      title: "Date Time",
      dataIndex: "timestamp",
      key: "Title",
      className: "abha-link-date",
      render: (value, item, index) => {
        return (
          <span>
            {/* {moment.utc(JSON.parse(item?.response_raw_data || "{}")?.timestamp)}
             */}
            <>{moment.utc(item.createdAt).format("DD-MM-YYYY H:mm:ss")}</>
          </span>
        );
      }
    },
    {
      title: "Requested Data",
      dataIndex: "Status",
      key: "Status",
      className: "table_status_col",
      render: (value, item, index) => {
        return (
          <Button
            className="view-btn"
            type="primary"
            onClick={() => {
              setRaw(JSON.parse(item?.request_raw_data || "{}"));
              setModal1Open(true);
            }}
          >
            {" "}
            View
          </Button>
        );
      }
    },
    {
      title: "Response Data",
      dataIndex: "Status",
      key: "Status",
      className: "table_status_col",
      render: (value, item, index) => {
        return (
          <Button
            className="view-btn"
            type="primary"
            onClick={() => {
              setRaw(JSON.parse(item?.response_raw_data || "{}"));
              setModal1Open(true);
            }}
          >
            {" "}
            View
          </Button>
        );
      }
    }
    //     {
    //         title: 'Action',
    //         dataIndex: 'action',
    //         key: 'actiion',
    // className: 'abha-link-action',
    //         with: 400,
    //         render: (value, item, index) => {
    //             return (
    //                 <> <Tooltip placement="top" title={"Link & Notify"}>
    //                     <a style={{ textDecoration: "underline" }} href={"#"}><LinkOutlined /></a>
    //                     </Tooltip>
    //                     <Tooltip placement="top" title={"Upload Report"}>
    //                     <Upload {...props}>
    //                         <Button className='view-btn' ><UploadOutlined /></Button>
    //                     </Upload>
    //                     </Tooltip>
    //                 </>
    //             )
    //         }
    //     },
  ];
  return (
    <div>
      <Row gutter={[10, 10]} align={"middle"}>
        <Col span={24}>
          <HeadingBack
            title={"Record Linked Log"}
            subHeading={`Records ${totalAbhaCardsLogs || 0}`}
          />
        </Col>
        <Col span={24}>
          <AbhaLinkedFilter
            filter={filter}
            setFilter={setFilter}
            setPage={setPage}
            headers={headers}
            FilteredData={FilteredData}
            setFilteredData={setFilteredData}
            filename={filename}
          />
        </Col>
        {/* <Col lg={2} md={24} sm={24} xs={24}>
                    <div className='flex justify-content-end align-items-center'>
                        <Tooltip title="Add"><span className='jop_btn' onClick={() => navigate("/faq/add")}>Add<SvgIcon.Add width={40} height={40} className="cursor-pointer" /></span></Tooltip>
                    </div>
                </Col> */}
      </Row>
      <div className="tableResponsive mt-10">
        <Table
          rowKey={(row) => row?.Id ?? row?.id}
          className={
            isLoading
              ? "table antd_table no_data_found_hide"
              : "table antd_table"
          }
          bordered
          columns={columns}
          dataSource={Array.isArray(HipLog) && HipLog?.length > 0 ? HipLog : []}
          pagination={{
            current: page,
            pageSize: limit,
            total: totalAbhaCardsLogs,
            onChange(current, pageSize) {
              setPage(current);
              // setOffset(current == 1 ? 0 : (((current - 1) * limit)));
            },
            hideOnSinglePage: true
          }}
        />
        <Modal
          style={{
            top: 20
          }}
          open={modal1Open}
          onOk={() => setModal1Open(false)}
          onCancel={() => setModal1Open(false)}
          footer={null}
        >
          <pre>{JSON.stringify(raw, null, 2)}</pre>
        </Modal>
      </div>
    </div>
  );
};

export default HipLog;
